import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Graphql from '@/views/Graphql.vue';
import MRegister from '@/views/MRegister.vue';
import learning from './learning';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/graphql',
      name: 'graphql',
      component: Graphql,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/m-register',
      name: 'mRegister',
      component: MRegister,
    },
    {
      path: '/print-exam',
      name: 'print-exam',
      component: () => import(/* webpackChunkName: "PrintExam" */ '@/views/learning/course/PrintExam.vue'),
    },
    learning,
  ],
});
